<style src="./AccountMovement.scss" lang="scss"></style>
<template>
  <div class="wrapper wrapper-content animated fadeIn">
    <header class="header-content">
      <div class="month-predict">
        <table class="table table-hover table-mail">
          <thead class="table-head">
            <tr>
              <th>Recebido</th>
              <th>Receb. Previsto</th>
              <th>Gasto</th>
              <th>Gastos Previsto</th>
              <th>Total Previsto</th>
            </tr>
          </thead>

          <tbody class="table-list">
            <tr>
              <td class="positive">
                R$ {{ totalToCurrencyBR(monthPredict.paidReceives) }}
              </td>
              <td class="positive">
                R$ {{ totalToCurrencyBR(monthPredict.unPaidReceives) }}
              </td>
              <td class="negative">
                R$ {{ totalToCurrencyBR(monthPredict.paidExpenses) }}
              </td>
              <td class="negative">
                R$ {{ totalToCurrencyBR(monthPredict.unPaidExpenses) }}
              </td>
              <td
                class="negative"
                :class="{
                  positive: monthPredict.foreseenTotal > 0,
                }"
              >
                R$ {{ totalToCurrencyBR(monthPredict.foreseenTotal) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="form-group">
        <select class="form-control" v-model="selectedAccount">
          <option
            v-for="(account, index) in accounts"
            :key="index"
            :value="account"
          >
            {{ account.name }}
          </option>
        </select>
        <br />
        <div class="form-group">
          <span class="label label-primary pull-right amount-content">
            Saldo: R$ {{ totalToCurrencyBR(selectedAccount?.actualBalance) }}
          </span>
        </div>
        <br />
        <div class="form-group">
          <span class="label label-success pull-right amount-content">
            Previsto: R$
            {{ totalToCurrencyBR(monthPredict.foreseenBalance) }}
          </span>
        </div>
      </div>
    </header>

    <MovementsList
      :selected-account="selectedAccount"
      @refresh-account="listAccounts"
      @update-range="getMonthPredict"
    />
  </div>
</template>

<script>
import MovementsList from './components/movement-list/MovementList';
import { toast } from '@/plugins/toast';

export default {
  components: {
    MovementsList,
  },
  data() {
    return {
      selectedAccount: {},
      accounts: [],
      monthPredict: {
        foreseenTotal: '',
        foreseenBalance: '',
        paidReceives: '',
        unPaidReceives: '',
        paidExpenses: '',
        unPaidExpenses: '',
      },
    };
  },

  mounted() {
    this.listAccounts();
  },
  methods: {
    totalToCurrencyBR(value) {
      return (value / 100).toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
      });
    },
    async listAccounts() {
      try {
        const accounts = await this.$store.dispatch(
          'FINANCIAL-ACCOUNT/ListAll',
        );
        const defaultAccount = accounts.find(
          (acc) => acc.defaultAccount === true,
        );
        if (!this.selectedAccount._id) this.selectedAccount = defaultAccount;
        else {
          this.selectedAccount = accounts.find(
            (acc) => String(acc._id) === String(this.selectedAccount._id),
          );
        }
        this.accounts = accounts;
      } catch (error) {
        toast.error('Não foi possível listar as contas');
      }
    },
    async getMonthPredict(range) {
      try {
        if (!this.selectedAccount._id) {
          return;
        }
        const monthPredict = await this.$store.dispatch(
          'FINANCIAL-ACCOUNT/MonthPredict',
          {
            selectedAccount: this.selectedAccount._id,
            range,
          },
        );
        this.monthPredict.foreseenTotal = monthPredict.foreseenTotal;
        this.monthPredict.foreseenBalance = monthPredict.foreseenBalance;
        this.monthPredict.paidReceives = monthPredict.paidReceives;
        this.monthPredict.unPaidReceives = monthPredict.unPaidReceives;
        this.monthPredict.paidExpenses = monthPredict.paidExpenses;
        this.monthPredict.unPaidExpenses = monthPredict.unPaidExpenses;
      } catch (error) {
        toast.error('Não foi possível listar o resumo mensal');
      }
    },
  },
};
</script>

